class Accordion {
  private el: HTMLElement;
  private rows: HTMLElement[];
  private buttons: HTMLButtonElement[];

  constructor(el: HTMLElement) {
    this.el = el;
    this.rows = Array.from(this.el.querySelectorAll<HTMLElement>('.accordion-row'));
    this.buttons = Array.from(this.el.querySelectorAll<HTMLButtonElement>('.accordion-button'));

    this.init();
  }

  private init() {
    this.buttons.forEach((button, index) => {
      this.syncRow(index, false);

      button.addEventListener('click', () => {
        this.toggleRow(index);
      });
    });
  }

  private getPanel(button: HTMLButtonElement): HTMLElement | null {
    const panelId = button.getAttribute('aria-controls');
    if (!panelId) return null;

    return document.getElementById(panelId);
  }

  private syncRow(index: number, expanded: boolean) {
    const row = this.rows[index];
    const button = this.buttons[index];
    const panel = this.getPanel(button);

    row.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (panel) {
      panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    }
  }

  private toggleRow(index: number) {
    this.rows.forEach((row, i) => {
      const isExpanded = row.classList.contains('is-expanded');

      if (i === index) {
        this.syncRow(i, !isExpanded);
      } else {
        this.syncRow(i, false);
      }
    });
  }
}

export default Accordion;
